import {
  type FetchResult,
  type MutationFunctionOptions,
  useMutation,
} from '@apollo/react-hooks';
import gql from 'graphql-tag';
/**
 * mutation, get the rule by institution and countryRegion
 */
export const useGetGPAConvertRule = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [getGPAConvertRule] = useMutation(gql`
    mutation ($institution: String!, $countryRegion: String!, $ruleId: String) {
      convertGPARule(
        input: {
          institutionName: $institution
          countryRegion: $countryRegion
          ruleId: $ruleId
        }
      ) {
        matchedRules {
          _id
          ruleName
          maxGPARange
          minGPARange
          note
          content
        }
        defaultRule {
          _id
          ruleName
          maxGPARange
          minGPARange
          note
          content
        }
      }
    }
  `);

  return getGPAConvertRule;
};
